import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import { CancelRounded } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import { listUserGroupProvider } from 'api/cms/user_group';
import UserGroupDialog from 'components/admin/provider_config/UserGroup';
import Breadcrumbs from 'components/Breadcrumbs';
import ApplicationLayout from 'components/layouts/ApplicationLayout';
import { useState } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import useSWR from 'swr';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGlow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  gridLayout: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const ProviderConfig = () => {
  const classes = useStyles();
  const [searchObj, setSearch] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const { data } = useSWR('/user_group/provider/list', () =>
    listUserGroupProvider({ page: page, limit: limit }),
  );
  let match = useRouteMatch();

  const handleOpenCreateDialog = () => {
    setOpenCreateDialog(true);
  };

  const handleCloseCreateDialog = () => {
    setOpenCreateDialog(false);
  };

  return (
    <ApplicationLayout>
      <Breadcrumbs />
      <Grid className={classes.gridLayout}>
        <Box bgcolor={'white'} className={classes.paper}>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6" gutterBottom component="div">
              Provider Group Config
            </Typography>
            <Button color="primary" variant="contained" onClick={() => handleOpenCreateDialog()}>
              Create Group
            </Button>
          </Box>
        </Box>
      </Grid>
      <TableContainer component={Paper}>
        <Table aria-label="simple table" size="small">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Provider Name</TableCell>
              <TableCell>Provider Code</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              data.providers.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <img src={row.provider_logo} height={30} />
                  </TableCell>
                  <TableCell>{row.provider_name}</TableCell>
                  <TableCell>{row.provider_code}</TableCell>
                  <TableCell>
                    <Link to={`${match.url}/${row.provider_code}`}>
                      <Button variant="contained" color="secondary">
                        See Group
                      </Button>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <UserGroupDialog row={null} open={openCreateDialog} handleClose={handleCloseCreateDialog} />
    </ApplicationLayout>
  );
};

export default ProviderConfig;
